import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { ref, watch } from "vue";
import { useFirmwareStore } from "@/stores";


export default /*@__PURE__*/_defineComponent({
  __name: 'ConsoleOutput',
  setup(__props, { expose: __expose }) {

const firmware = useFirmwareStore();
const consoleOutput = ref<HTMLElement | null>(null);

const scroll = () => {
  if (consoleOutput.value == null) return;
  consoleOutput.value.scrollTop = consoleOutput.value.scrollHeight;
};

watch(
  () => firmware.consoleOutputCount,
  (newCount) => {
    if (newCount == 0) return;
    // Run the scrolling now, but also in next event cycle to make sure we actually
    // scroll till the end.
    scroll();
    setTimeout(scroll);
  }
);

__expose({ scroll });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("pre", {
    class: "font-mono overflow-auto text-xs w-full h-full p-1 px-2 pb-7 rounded-box bg-neutral-focus text-neutral-content",
    ref_key: "consoleOutput",
    ref: consoleOutput,
    innerHTML: _unref(firmware).consoleOutputHtml
  }, null, 8, _hoisted_1))
}
}

})